import { Language } from '@yleisradio/areena-types';
import { getTranslation } from '../localizations/translations';
import { cloudinaryHostname } from '../environment';

const dataProtectionQrFi = `https://${cloudinaryHostname}/image/upload/v1746772308/areena/data-protection-link_fi.png`;
const dataProtectionQrSv = `https://${cloudinaryHostname}/image/upload/v1746772308/areena/data-protection-link_sv.png`;

/*
 * Content needs to be valid XHTML because of HBBTV-support, verify any changes with this setup!
 */
export function generateDataProtectionHtml(
  language: Language,
  title: string
): string {
  return `
    <h1>${title}</h1>
    <div class="logo-with-text">
      <img src="${
        language === 'sv' ? dataProtectionQrSv : dataProtectionQrFi
      }" />
      <div class="logo-text">
       <p>${getTranslation('dataProtection_scan', language)}</p>
       <p>${getTranslation('dataProtection_orVisit', language)}</p>
      </div>
    </div>
  `;
}
